var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "List View") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Views-/-List-Black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layout-bullets"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 8.25,
    y: 0.747,
    width: 15,
    height: 4.5,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 8.25,
    y: 9.747,
    width: 15,
    height: 4.5,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 8.25,
    y: 18.747,
    width: 15,
    height: 4.5,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.75,
    y: 0.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.75,
    y: 9.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.75,
    y: 18.747,
    width: 4.5,
    height: 4.5,
    rx: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.03c3b3186da8c204a0576b1256217866.svg";
export { ForwardRef as ReactComponent };